import { Account } from 'mdi-material-ui';
import SectionCard from '../../components/SectionCard';
import useMsftReferral from '../../hooks/useMsftReferral';
import MemberList from './MemberList';
import { formatFullName } from '../../utils/comboFormatting';

const TeamMembersSection = ({ tackleId }: { tackleId: string }) => {
  const { data: referral } = useMsftReferral({ tackleId });

  if (!referral) return null;
  const members = referral.team || [];

  return (
    <SectionCard
      icon={<Account data-testid="user-icon" style={{ fill: '#253858' }} />}
      title="Team members"
      bodyStyle={{ paddingBlock: '0', paddingBottom: '1.5rem' }}
    >
      <MemberList>
        <MemberList.Header
          columnHeaders={['Team member name', 'Email', 'Phone']}
        />
        {members.map((member, i) => (
          <MemberList.Item
            key={`${member.firstName}-${i}`}
            name={formatFullName(member)}
            email={member.email}
            phoneNumber={member.phoneNumber}
          />
        ))}
      </MemberList>
    </SectionCard>
  );
};

export default TeamMembersSection;
